export default __webpack_public_path__ + "static/media/warning-icon.1437e560.svg";